import type { Category, ItemOffer } from "@/types"

/**
 * The offer of `itemId` a customer can order from the menu `categories` belong to. An offer only
 * reachable as an option inside another product is not on the menu, so it never matches.
 */
export function findMenuOfferForItem(
  itemId: string,
  itemOffers: ItemOffer[],
  categories: Category[],
  accept: (offer: ItemOffer) => boolean = () => true,
): ItemOffer | null {
  const onMenu = new Set(categories.flatMap((category) => category.itemOfferId ?? []))
  return (
    itemOffers.find((offer) => offer.itemId === itemId && onMenu.has(offer.id) && accept(offer)) ?? null
  )
}
